// SSC应用安装组件
import AppInstallPanel from './src/app-install-panel';

export default AppInstallPanel;
